export const Events = {
  UPDATE_ON_DELETE_ASSET: 'update-on-delete-asset'
}
